import { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Table } from "./Table";
import { Form } from "./Form";

interface IVendorCompany {
  vendor_Company_ID: number;
  vendor_Company_Name: string;
  website_URL?: string;
}

export interface ITenderClientPOC {
  tender_Client_Name?: string;
  contact_Person_ID?: number;
  vendor_Company_ID?: number;
  vendor_Company?: IVendorCompany;
  Vendor_Company_ID?: number;
  vendor_Company_Name?: string;
  contact_Person_EmailID?: string;
  contact_Person_Name?: string;
  designation?: number;
  designation_Name?: string;
  department?: number;
  phone_No?: string;
  cell_No?: string;
  add_by_User?: number;
  major_Technology?: string;
  ext?: string;
  department_ID?: number;
}

export const EmptyPOC: ITenderClientPOC = {
  contact_Person_ID: 0,
  vendor_Company_ID: 0,
  vendor_Company: {
    vendor_Company_ID: 0,
    vendor_Company_Name: "",
  },
  Vendor_Company_ID: 0,
  vendor_Company_Name: "",
  contact_Person_EmailID: "",
  contact_Person_Name: "",
  designation: 0,
  designation_Name: "",
  department: 0,
  phone_No: "",
  cell_No: "",
  add_by_User: 0,
  ext:""
 
};

export const TenderClientPOC = () => {
  const [modal, setModal] = useState({ singleData: EmptyPOC, open: false } as { singleData: ITenderClientPOC; open: boolean });
  const [reload, setReload] = useState<boolean>(false);
  const toast = useRef<any>(null);
  const hideDialog = () => {
    setModal({ singleData: EmptyPOC, open: false });
  };

  return (
    <>
      <Table setModal={setModal} toast={toast} reload={reload} />
      <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} />
      <Toast ref={toast} />
    </>
  );
};
